// Ticket 27: Lounge Gift Button Component
import React, { useState } from 'react';
import GiftPickerModal from './GiftPickerModal';

const LoungeGiftButton = ({ roomId, participant }) => {
  const [showPicker, setShowPicker] = useState(false);

  const handleOpenPicker = () => {
    setShowPicker(true);
  }

  const handleClosePicker = () => {
    setShowPicker(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpenPicker}
        className="mt-1 px-2 py-0.5 rounded-full bg-pink-600/90 hover:bg-pink-500 text-white text-[10px] font-semibold transition-colors"
        title="Send a gift"
      >
        💜 Gift
      </button>

      {showPicker && (
        <GiftPickerModal
          open={showPicker}
          onClose={handleClosePicker}
          targetUserId={participant.user_id}
          recipientName={participant.first_name || participant.display_name || 'Guest'}
          
          // NEW: tell the modal this is a lounge gift
          isLoungeGift={true}
          loungeRoomKey={roomId}
        />
      )}
    </>
  );
};

export default LoungeGiftButton;
